import { responsiveCard } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const documentContainerStyle = recipe({
  base: {
    height: "100%",
    padding: `${theme.spacings.l} ${theme.spacings.xl}`,
    display: "none",
    ...responsiveCard({
      600: {
        display: "flex",
      },
    }),
  },
  variants: {
    variant: {
      default: {},
      compact: {},
    },
  },
});

export const documentStyle = recipe({
  base: {
    width: rem(200),
    aspectRatio: "1/1.4142",
    backgroundColor: theme.colors.background,
    margin: "auto",
    borderRadius: theme.borderRadiuses.xs,
    padding: theme.spacings.m,
    userSelect: "none",
    selectors: {
      "&:before, &:after": {
        content: "",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: theme.colors.background,
        borderRadius: theme.borderRadiuses.xs,
        zIndex: -1,
      },
      "&:before": {
        transform: "translateX(10%) scale(.9) rotate(1deg)",
        opacity: 0.75,
      },
      "&:after": {
        transform: "translateX(20%) scale(.8) rotate(2deg)",
        opacity: 0.5,
      },
    },
  },
  variants: {
    variant: {
      default: {},
      compact: {},
    },
  },
});

export const documentLogoStyle = style({});

export const documentTitleStyle = style({});

export const documentSubtitleStyle = style({});

export const documentIFrameStyle = style({
  width: "100%",
  aspectRatio: "1/1.4142",
  maxHeight: "calc(100dvh - 300px)",
  border: "none",
  borderRadius: theme.borderRadiuses.s,
  overflow: "hidden",
});

export const cardContentStyle = style({
  justifyContent: "center",
});
